/**
 * Traps focus within a specified container element.
 * @param {string} focusContainerId - The selector for the focus container (e.g., '#loginModal').
 */
export default function focusTrap(focusContainerId: string): void {
  const FOCUSABLE_ELEMENTS =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  const modal = document.querySelector<HTMLElement>(focusContainerId)

  if (!modal) {
    // Modal not found; do not proceed
    return
  }

  const focusableContent = modal.querySelectorAll(FOCUSABLE_ELEMENTS)
  const firstFocusableElement = focusableContent[0] as HTMLElement | undefined
  const lastFocusableElement = focusableContent[focusableContent.length - 1] as
    | HTMLElement
    | undefined

  document.addEventListener('keydown', function handleKeyDown(event) {
    const isTabPressed = event.key === 'Tab'
    if (!isTabPressed) {
      return
    }
    if (event.shiftKey) {
      if (
        document.activeElement === firstFocusableElement &&
        lastFocusableElement
      ) {
        lastFocusableElement.focus()
        event.preventDefault()
      }
    } else {
      if (
        document.activeElement === lastFocusableElement &&
        firstFocusableElement
      ) {
        firstFocusableElement.focus()
        event.preventDefault()
      }
    }
  })

  if (firstFocusableElement) {
    firstFocusableElement.focus()
  }
}
